import { render } from "./collegeAmendSign.vue?vue&type=template&id=77b31b40&scoped=true&ts=true"
import script from "./collegeAmendSign.vue?vue&type=script&lang=ts"
export * from "./collegeAmendSign.vue?vue&type=script&lang=ts"

import "./collegeAmendSign.vue?vue&type=style&index=0&id=77b31b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b31b40"]])

export default __exports__